export const API_URL = 'https://api.staging-perfectdeed.com/api';
export const BASE_URL = 'https://app.staging-perfectdeed.com';
export const REACT_APP_BUCKET_NAME = 'staging-perfectdeed';

export const FACEBOOK_APP_ID = '336794043951056';
export const GOOGLE_CLIENT_ID = '833608585057-v84jsll6b8mgtvhino7n5b1k73l49nue.apps.googleusercontent.com';
export const GOOGLE_CLIENT_SECRET = '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';
